var map = {
	"./logo-blw.png": "57c0",
	"./logo-ckg.png": "760d",
	"./logo-dark.png": "59da",
	"./logo-default.png": "6325",
	"./logo-depotest.png": "b0a3",
	"./logo-dkm.png": "4e5f",
	"./logo-java.png": "2feb",
	"./logo-jkt.png": "a572",
	"./logo-jsmslpg.png": "0984",
	"./logo-jsmssmg.png": "c116",
	"./logo-light.png": "ea27",
	"./logo-mydeposys.png": "228c",
	"./logo-sby.png": "78fa",
	"./logo-smg.png": "01a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8abc";